module.exports = __webpack_public_path__ + "static/img/it4d-trote.13f2a50.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/it4d-trote.png
// module id = exUy
// module chunks = 4